/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [];




export const defaultNavigationAdmin: FuseNavigationItem[] = [

    {
        id      : 'cuenta',
        title   : 'Cuenta',
        // subtitle: 'Unique dashboard designs',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id   : 'dashboards.project',
                title: 'Configuración',
                type : 'basic',
                icon : 'heroicons_outline:cog',
                link : '/acount/settings'
            }
        ]
    },

    {
        id      : 'administracion',
        title   : 'Administración',
        // subtitle: 'Unique dashboard designs',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id   : 'module.paciente',
                title: 'Mis pacientes',
                type : 'basic',
                icon : 'heroicons_outline:user',
                link : '/paciente'
            },
            {
                id   : 'module.medico',
                title: 'Nutriólogos',
                type : 'basic',
                link : '/doctors/list',
                icon    : 'heroicons_outline:collection',
            },
            {
                id   : 'module.suscriptions',
                title: 'Suscripciones',
                type : 'basic',
                link : '/doctors/suscriptions',
                icon    : 'heroicons_outline:collection',
            },
            {
                id   : 'module.suscriptions-cancel',
                title: 'Suscripciones canceladas',
                type : 'basic',
                link : '/doctors/suscriptions-cancel',
                icon    : 'heroicons_outline:collection',
            },
            {
                id   : 'module.suscriptions-pagos',
                title: 'Pagos',
                type : 'basic',
                link : '/doctors/suscriptions-pagos',
                icon    : 'heroicons_outline:collection',
            },
            {
                id      : 'module.paypal',
                title   : 'PayPal',
                type    : 'collapsable',
                icon    : 'heroicons_outline:collection',
                children: [
                    {
                        id   : 'module.catalogue.planes',
                        title: 'Planes',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/planes'
                    }
                ]
            },
            {
                id      : 'agenda.group',
                title   : 'Agenda',
                type    : 'collapsable',
                icon    : 'heroicons_outline:calendar',
                children: [
                    {
                        id   : 'agenda.group.agenda',
                        title: 'Agendar cita',
                        type : 'basic',
                        link : '/agenda/administrar'
                    },
                    {
                        id   : 'agenda.group.horarios',
                        title: 'Horarios Laborales',
                        type : 'basic',
                        link : '/agenda/horarios'
                    },
                    {
                        id   : 'agenda.group.excepciones',
                        title: 'Excepciones Laborales',
                        type : 'basic',
                        link : '/agenda/excepciones'
                    },


                ]
            },
            {
                id      : 'module.catalogue',
                title   : 'Catálogo',
                type    : 'collapsable',
                icon    : 'heroicons_outline:collection',
                children: [
                    {
                        id   : 'module.catalogue.escolaridad',
                        title: 'Escolaridad',
                        type : 'basic',
                        link : '/catalogo/escolaridad'
                    },
                    {
                        id   : 'module.catalogue.estilovida',
                        title: 'Estilo de vida',
                        type : 'basic',
                        link : '/catalogo/estilo-de-vida'
                    },

                    {
                        id   : 'module.catalogue.grupoalimento',
                        title: 'Grupo de alimentos',
                        type : 'basic',
                        link : '/catalogo/grupos-de-alimento'
                    },

                    {
                        id   : 'module.catalogue.medidaporcion',
                        title: 'Medidas de porción',
                        type : 'basic',
                        link : '/catalogo/porcion-de-medida'
                    },
                    {
                        id   : 'module.catalogue.tiposangre',
                        title: 'Tipo de sangre',
                        type : 'basic',
                        link : '/catalogo/tipo-de-sangre'
                    },

                    {
                        id   : 'module.catalogue.unidadmedida',
                        title: 'Unidad de medida',
                        type : 'basic',
                        link : '/catalogo/unidad-de-medida'
                    }

                ]
            },
        ]
    },

    {
        id      : 'alimentos',
        title   : 'Alimentos',
        // subtitle: 'Unique dashboard designs',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id      : 'module.receta',
                title   : 'Administración',
                type    : 'collapsable',
                icon    : 'heroicons_outline:collection',
                children: [
                    {
                        id   : 'module.receta.listado',
                        title: 'Recetas Globales',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/recetas/globales'
                    },
                    {
                        id   : 'module.receta.listado',
                        title: 'Recetas Validadas',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/recetas/validadas'
                    },
                    {
                        id   : 'module.receta.listado',
                        title: 'Recetas por Validar',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/recetas/porValidar'
                    },
                    {
                        id   : 'module.receta.detail',
                        title: 'Ingredientes Globales',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/ingredientes/globales'
                    },
                    {
                        id   : 'module.receta.detail',
                        title: 'Ingredientes Validados',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/ingredientes/validados'
                    },
                    {
                        id   : 'module.receta.detail',
                        title: 'Ingredientes por Validar',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/ingredientes/porValidar'
                    },
                    {
                        id   : 'module.receta.plantilla',
                        title: 'Premenús',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/plantillas/todas'
                    },
                ]
            },
        ]
    },
];


export const defaultNavigationMedico: FuseNavigationItem[] = [

    {
        id      : 'cuenta',
        title   : 'Cuenta',
        // subtitle: 'Unique dashboard designs',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id   : 'dashboards.project',
                title: 'Configuración',
                type : 'basic',
                icon : 'heroicons_outline:cog',
                link : '/acount/settings'
            },
            {
                id   : 'count.payments',
                title: 'Pagos',
                type : 'basic',
                icon : 'heroicons_outline:credit-card',
                link : '/acount/payments'
            },
            {
                id      : 'agenda.group',
                title   : 'Agenda',
                type    : 'collapsable',
                icon    : 'heroicons_outline:calendar',
                children: [
                    {
                        id   : 'agenda.group.agenda',
                        title: 'Agendar cita',
                        type : 'basic',
                        link : '/agenda/administrar'
                    },
                    {
                        id   : 'agenda.group.horarios',
                        title: 'Horarios Laborales',
                        type : 'basic',
                        link : '/agenda/horarios'
                    },
                    {
                        id   : 'agenda.group.excepciones',
                        title: 'Excepciones Laborales',
                        type : 'basic',
                        link : '/agenda/excepciones'
                    },


                ]
            },
        ]
    },


    {
        id      : 'paciente',
        title   : 'paciente',
        // subtitle: 'Unique dashboard designs',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id   : 'dashboards.project',
                title: 'Mis pacientes',
                type : 'basic',
                icon : 'heroicons_outline:user',
                link : '/paciente'
            }
        ]
    },

    {
        id      : 'alimentos',
        title   : 'Alimentos',
        // subtitle: 'Unique dashboard designs',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id      : 'module.receta',
                title   : 'Administración',
                type    : 'collapsable',
                icon    : 'heroicons_outline:collection',
                children: [
                    {
                        id   : 'module.receta.listado',
                        title: 'Recetas',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/recetas/todas'
                    },
                    {
                        id   : 'module.receta.detail',
                        title: 'Ingredientes',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/ingredientes/todos'
                    },
                    {
                        id   : 'module.receta.plantilla',
                        title: 'Premenús',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/plantillas/todas'
                    },


                ]
            },
        ]
    },

];



export const defaultNavigationAuxiliar: FuseNavigationItem[] = [



    {
        id      : 'cuenta',
        title   : 'Cuenta',
        // subtitle: 'Unique dashboard designs',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id   : 'dashboards.project',
                title: 'Configuración',
                type : 'basic',
                icon : 'heroicons_outline:cog',
                link : '/acount/settings'
            }
        ]
    },


    {
        id      : 'administracion',
        title   : 'Administración',
        // subtitle: 'Unique dashboard designs',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id      : 'module.catalogue',
                title   : 'Catálogo',
                type    : 'collapsable',
                icon    : 'heroicons_outline:collection',
                children: [
                    {
                        id   : 'module.catalogue.escolaridad',
                        title: 'Escolaridad',
                        type : 'basic',
                        link : '/catalogo/escolaridad'
                    },
                    {
                        id   : 'module.catalogue.estilovida',
                        title: 'Estilo de vida',
                        type : 'basic',
                        link : '/catalogo/estilo-de-vida'
                    },

                    {
                        id   : 'module.catalogue.grupoalimento',
                        title: 'Grupo de alimentos',
                        type : 'basic',
                        link : '/catalogo/grupos-de-alimento'
                    },

                    {
                        id   : 'module.catalogue.medidaporcion',
                        title: 'Medidas de porción',
                        type : 'basic',
                        link : '/catalogo/porcion-de-medida'
                    },
                    {
                        id   : 'module.catalogue.tiposangre',
                        title: 'Tipo de sangre',
                        type : 'basic',
                        link : '/catalogo/tipo-de-sangre'
                    },

                    {
                        id   : 'module.catalogue.unidadmedida',
                        title: 'Unidad de medida',
                        type : 'basic',
                        link : '/catalogo/unidad-de-medida'
                    },

                ]
            },
        ]
    },

    {
        id      : 'paciente',
        title   : 'paciente',
        // subtitle: 'Unique dashboard designs',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id   : 'dashboards.project',
                title: 'Mis pacientes',
                type : 'basic',
                icon : 'heroicons_outline:user',
                link : '/paciente'
            }
        ]
    },

    {
        id      : 'alimentos',
        title   : 'Alimentos',
        // subtitle: 'Unique dashboard designs',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id      : 'module.receta',
                title   : 'Administración',
                type    : 'collapsable',
                icon    : 'heroicons_outline:collection',
                children: [
                    {
                        id   : 'module.receta.listado',
                        title: 'Recetas Globales',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/recetas/globales'
                    },
                    {
                        id   : 'module.receta.listado',
                        title: 'Recetas Validadas',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/recetas/validadas'
                    },
                    {
                        id   : 'module.receta.listado',
                        title: 'Recetas por Validar',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/recetas/porValidar'
                    },
                    {
                        id   : 'module.receta.detail',
                        title: 'Ingredientes Globales',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/ingredientes/globales'
                    },
                    {
                        id   : 'module.receta.detail',
                        title: 'Ingredientes Validados',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/ingredientes/validados'
                    },
                    {
                        id   : 'module.receta.detail',
                        title: 'Ingredientes por Validar',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/ingredientes/porValidar'
                    },
                    {
                        id   : 'module.receta.plantilla',
                        title: 'Premenús',
                        type : 'basic',
                        link : '/catalogo/administracion/listado/plantillas/todas'
                    },


                ]
            },
        ]
    }

];



export const compactNavigation: FuseNavigationItem[] = [ ];
export const futuristicNavigation: FuseNavigationItem[] = [];
export const horizontalNavigation: FuseNavigationItem[] = [];
